import { render, staticRenderFns } from "./account-franchisor.vue?vue&type=template&id=f7528684&"
import script from "./account-franchisor.vue?vue&type=script&lang=js&"
export * from "./account-franchisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports